// extracted by mini-css-extract-plugin
export default {"wrapper":"LanguageCompliancePage_wrapper__1FO9t","tabs":"LanguageCompliancePage_tabs__mh50j"};